<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :label-position="labelPosition" label-width="80px" :rules="rules" :model="ruleForm">
      <el-form-item label="充值类型" prop="rechargeType">
        <el-select v-model="ruleForm.rechargeType" placeholder="请选择" @change="zhocwer">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.rechargeType == 0" label="充值金额" prop="price" class="demo-ruleForm ">
        <el-input v-model="ruleForm.price" style="width:200px" min="1" type="number" placeholder="请输入内容" @blur="cznum" />
        <span> * 介于1-300元之间,最多两位小数</span>
      </el-form-item>
      <el-form-item v-if="ruleForm.rechargeType == 0" label="赠送金额" prop="hongbao" class="demo-ruleForm ">
        <div style="display:flex">
          <el-input v-model="ruleForm.hongbao" style="width:200px" min="1" type="number" placeholder="请输入内容" @blur="zsnum" />
          <div class="daserw"> * 充值金额为1-9元，赠送金额不能超过充值金额的2.5倍，且最大不超过20元；大于9元的，赠送金额不超过充值金额的1.5倍</div>
        </div>

      </el-form-item>
      <el-form-item v-if="ruleForm.rechargeType == 1" label="充值项" prop="vipConfigId">
        <el-select v-model="ruleForm.vipConfigId" placeholder="请选择" @change="vipchange">
          <el-option
            v-for="item in vipconfigoptions"
            :key="item.value"
            :label="item.description"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="限购次数" prop="cishununer">
        <el-radio-group v-model="ruleForm.xiangouradio">
          <el-radio :label="0">共
            <el-select v-model="ruleForm.gong" placeholder="请选择">
              <el-option
                v-for="item in optionsr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            次
          </el-radio>
          <el-radio :label="1">每天
            <el-select v-model="ruleForm.mei" placeholder="请选择">
              <el-option
                v-for="item in optionsr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            次
          </el-radio>
          <el-radio :label="str">不限次数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-top:10px" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  // props: {
  //   platformid: {
  //     type: Number,
  //     default: null
  //   }
  // },
  data() {
    var checkAge = (rule, value, callback) => {
      if (this.ruleForm.xiangouradio === 0 && this.ruleForm.gong === '') {
        callback(new Error('选择共几次'))
      } else if (this.ruleForm.xiangouradio === 1 && this.ruleForm.mei === '') {
        callback(new Error('选择每天次数'))
      } else {
        callback()
      }
    }
    return {
      options: [{
        value: 0,
        label: '普通充值'
      }, {
        value: 1,
        label: 'VIP'
      }],
      vipconfigoptions: [],
      optionsr: [{
        value: 1,
        label: '1次'
      }, {
        value: 2,
        label: '2次'
      }, {
        value: 3,
        label: '3次'
      }, {
        value: 4,
        label: '4次'
      }, {
        value: 5,
        label: '5次'
      },
      {
        value: 6,
        label: '6次'
      },
      {
        value: 7,
        label: '7次'
      },
      {
        value: 8,
        label: '8次'
      },
      {
        value: 9,
        label: '9次'
      },
      {
        value: 10,
        label: '10次'
      }],
      labelPosition: 'right',
      ruleForm: {
        rechargeType: null,
        price: '',
        hongbao: '',
        vipConfigId: null,
        vipxuanzexiang: '', // vip充值项叙述文字
        xiangouradio: 0,
        gong: '',
        mei: '',
        gongmeichuan: null

      },
      str: '',
      rules: {
        rechargeType: [
          { type: 'number', required: true, message: '请选择充值类型', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { pattern: /^(?!0+$)(?!0*\.0*$)\d{1,8}(\.\d{1,2})?$/, message: '最多有两位小数', trigger: 'blur' }
        ],
        hongbao: [
          { required: true, message: '请输入赠送金额', trigger: 'blur' }
          // { pattern: /^(?!0+$)(?!0*\.0*$)\d{1,8}(\.\d{1,2})?$/, message: '最多有两位小数', trigger: 'blur' }
        ],
        vipConfigId: [
          { required: true, message: '请选择充值项', trigger: 'change' }
        ],
        cishununer: [
          { validator: checkAge, trigger: 'blur' }
        ]
      },
      platformid: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line eqeqeq
          if (this.ruleForm.xiangouradio == 1) {
            this.ruleForm.gongmeichuan = this.ruleForm.mei
            console.log('每')
          }
          // eslint-disable-next-line eqeqeq
          if (this.ruleForm.xiangouradio === 0) {
            this.ruleForm.gongmeichuan = this.ruleForm.gong
            console.log('共')
          }
          // eslint-disable-next-line eqeqeq
          if (this.ruleForm.xiangouradio == '' && this.ruleForm.xiangouradio !== 0) {
            this.ruleForm.gongmeichuan = -1
            console.log('不限')
          }
          console.log(this.ruleForm)
          this.$emit('callback', this.ruleForm)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1
      })
      this.vipconfigoptions = data.data.programme
      console.log('data', data)
    },
    zhocwer(val) {
      if (val === 0) {
        this.ruleForm.vipConfigId = null
        this.ruleForm.vipxuanzexiang = ''
      } else {
        this.ruleForm.price = ''
        this.ruleForm.hongbao = ''
      }
      this.$refs.ruleForm.clearValidate()
    },
    cznum() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.price <= 0 && this.ruleForm.price != '') {
        this.ruleForm.price = 1
      }
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.price > 300 && this.ruleForm.price != '') {
        this.ruleForm.price = 300
      }
    },
    zsnum() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.hongbao <= 0 && this.ruleForm.hongbao != '') {
        this.ruleForm.hongbao = 1
      }
    },
    send(val) {
      console.log('send', val)
      this.platformid = val
      this.getlistr()
    },
    vipchange(val) {
      console.log('val', val)
      this.vipconfigoptions.forEach((item, index) => {
        // eslint-disable-next-line eqeqeq
        if (item.value == val) {
          this.ruleForm.vipxuanzexiang = item.price
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.daserw{
  width: 300px;
  margin-left: 10px;
}
</style>
